<app-header></app-header>

<div class="p-4">

  <!-- En-tête -->
  <div class="flex items-center gap-3 mb-5 pl-3 border-l-4 border-ag-red">
    <div>
      <h2 class="text-lg font-bold text-gray-900 m-0">Gestion des dépenses</h2>
      <p class="text-xs text-gray-400 m-0">Suivi et catégorisation des dépenses de l'établissement</p>
    </div>
  </div>

  <!-- Synthèse -->
  @if (summary) {
    <div class="grid grid-cols-1 md:grid-cols-4 gap-3 mb-5">
      <div class="rounded-xl border border-gray-100 bg-white p-4 shadow-sm md:col-span-1">
        <p class="text-xs text-gray-400 uppercase tracking-wide m-0">Total dépenses</p>
        <p class="text-2xl font-bold text-ag-red mt-1 mb-0">{{summary.total | number}} <span class="text-sm font-normal">FCFA</span></p>
        <p class="text-xs text-gray-400 mt-1 mb-0">{{summary.count}} dépense(s)</p>
      </div>
      @for (c of summary.by_category; track c.category) {
        <div class="rounded-xl border border-gray-100 bg-white p-4 shadow-sm">
          <p class="text-xs text-gray-400 uppercase tracking-wide m-0 truncate">{{c.category}}</p>
          <p class="text-lg font-bold text-gray-800 mt-1 mb-0">{{c.total | number}} F</p>
          <p class="text-xs text-gray-400 mt-1 mb-0">{{c.count}} ligne(s)</p>
        </div>
      }
    </div>
  }

  <!-- Carte tableau -->
  <div class="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">

    <!-- Barre d'outils -->
    <div class="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-gray-100 bg-gray-50">
      @if (buttonsPermission?.add) {
        <button (click)="add(formContent)"
                class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold transition-colors">
          + Nouvelle dépense
        </button>
      }
      @if (selected_data && buttonsPermission?.edit) {
        <button (click)="edit(formContent)"
                class="px-3 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm transition-colors">
          Modifier
        </button>
      }
      @if (selected_data && buttonsPermission?.delete) {
        <button (click)="delete()"
                class="px-3 py-1.5 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-sm transition-colors">
          Supprimer
        </button>
      }
      <div class="ml-auto">
        <input type="text" [(ngModel)]="search_text" placeholder="Rechercher..."
               class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10 w-56">
      </div>
    </div>

    <app-loading [isVisible]="loading"></app-loading>

    <!-- Tableau -->
    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-start text-xs text-gray-400 uppercase tracking-wide">
            <th class="px-3 py-2 w-8"></th>
            <th class="px-3 py-2">Libellé</th>
            <th class="px-3 py-2">Catégorie</th>
            <th class="px-3 py-2">Bénéficiaire</th>
            <th class="px-3 py-2 text-end">Montant</th>
            <th class="px-3 py-2">Date</th>
            <th class="px-3 py-2">Paiement</th>
            <th class="px-3 py-2 text-center">Statut</th>
          </tr>
        </thead>
        <tbody>
          @for (d of data | sampleSearch:search_text:'label' | paginate:{id:'expPg', itemsPerPage:pg.pageSize, currentPage:pg.p, totalItems:pg.total}; track d.id) {
            <tr class="border-t border-gray-50 hover:bg-red-50/30 transition-colors">
              <td class="px-3 py-2"><input type="radio" [checked]="selected_data?.id === d.id" name="expRadio" (click)="checked(d)" class="accent-ag-red"></td>
              <td class="px-3 py-2 font-semibold text-gray-800">{{d.label}}</td>
              <td class="px-3 py-2">
                @if (d.category) { <span class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-xs">{{d.category}}</span> }
                @else { <span class="text-gray-300">—</span> }
              </td>
              <td class="px-3 py-2 text-gray-600">{{d.beneficiary || '—'}}</td>
              <td class="px-3 py-2 text-end font-semibold text-gray-800">{{d.amount | number}} F</td>
              <td class="px-3 py-2 text-gray-500">{{d.expense_date | date:'dd/MM/yyyy'}}</td>
              <td class="px-3 py-2 text-gray-500">{{d.payment_method || '—'}}</td>
              <td class="px-3 py-2 text-center">
                <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="statusClass(d.status)">{{statusLabel(d.status)}}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (!loading && data.length === 0) {
      <p class="text-center text-gray-400 py-8 text-sm">Aucune dépense enregistrée.</p>
    }

    <div class="flex justify-center py-3">
      <pagination-controls id="expPg" (pageChange)="getPage($event)"
                           [previousLabel]="'Précédent'" [nextLabel]="'Suivant'" [autoHide]="true">
      </pagination-controls>
    </div>
  </div>
</div>

<!-- Modal formulaire -->
<ng-template #formContent let-c="close" let-d="dismiss">
  <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 border-l-4 border-l-ag-red">
    <h5 class="font-bold text-gray-900 m-0">{{form.id ? 'Modifier' : 'Nouvelle'}} dépense</h5>
    <button type="button" (click)="d('x')" class="w-7 h-7 rounded-full hover:bg-gray-100 text-gray-400">✕</button>
  </div>
  <form #f="ngForm" (ngSubmit)="form.id ? update(form) : store(form)">
    <div class="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Libellé *</label>
        <input name="label" [(ngModel)]="form.label" required placeholder="Ex: Achat fournitures, Facture électricité..."
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Catégorie</label>
        <select name="category" [(ngModel)]="form.category" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          <option value="">— Choisir —</option>
          @for (c of CATEGORIES; track c) { <option [value]="c">{{c}}</option> }
        </select>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Montant (FCFA) *</label>
        <input name="amount" type="number" min="0" [(ngModel)]="form.amount" required
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Date *</label>
        <input name="expense_date" type="date" [(ngModel)]="form.expense_date" required
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Mode de paiement</label>
        <select name="payment_method" [(ngModel)]="form.payment_method" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          @for (p of PAYMENT_METHODS; track p) { <option [value]="p">{{p}}</option> }
        </select>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Bénéficiaire / Fournisseur</label>
        <input name="beneficiary" [(ngModel)]="form.beneficiary"
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Ligne budgétaire</label>
        <select name="budget_id" [(ngModel)]="form.budget_id" class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          <option [ngValue]="null">— Aucune —</option>
          @for (b of budgets; track b.id) { <option [ngValue]="b.id">{{b.label}}</option> }
        </select>
      </div>
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Description</label>
        <textarea name="description" rows="2" [(ngModel)]="form.description"
                  class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10"></textarea>
      </div>
    </div>
    <div class="flex justify-end gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
      <button type="button" (click)="d('x')" class="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Annuler</button>
      <button type="submit" [disabled]="f.invalid || loading"
              class="px-4 py-2 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-2">
        Enregistrer <app-loading [isVisible]="loading"></app-loading>
      </button>
    </div>
  </form>
</ng-template>
